<template>
  <div class="flats-counter">
    <div class="flats-counter__wrapper">
      <div class="flats-counter__row">
        <span class="flats-counter__count">{{ normalizeCount(count) }}</span>
        <div class="flats-counter__ready-text">
          <span>Готовых</span><br>
          <span>квартир</span>
        </div>
      </div>
      <div class="flats-counter__subtitle">
        {{ normalizeTitle(count, subtitle) }} в продаже
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'FlatsCounter',
  data() {
    return {
      title: ['Готовая квартира', 'Готовые квартиры', 'Готовых квартир'],
      subtitle: ['остался', 'осталось', 'осталось'],
      flats: [],
    }
  },
  methods: {
    normalizeTitle(num, dec) {
      if (num > 100) num = num % 100;
      if (num <= 20 && num >= 10) return dec[2];
      if (num > 20) num = num % 10;
      return num === 1 ? dec[0] : num > 1 && num < 5 ? dec[1] : dec[2];
    },
    normalizeCount(num) {
      return num < 10 ? `0${num}` : num
    },
    async fetchFlats() {
      try {
        const response = await axios.get(
          this.$endpoint + "building-objects/" + this.$project + "/properties"
        );
        this.flats = response.data.data;
      } catch (e) {
        this.flats = [];
      }
    }
  },
  computed: {
    count() {
      const filtered = this.flats.filter(
        (flat) =>
          (flat.building === '1' || flat.building === '2') &&
          (flat.status === 'booked' || flat.status === 'available') &&
          (flat.layout.type === 'flat')
      );
      return filtered.length;
    }
  },
  mounted() {
    this.fetchFlats();
  }
}
</script>

<style scoped>
.flats-counter {
  letter-spacing: 0.08em;
}

.flats-counter__wrapper {
  padding: 15px 25px;
  background: linear-gradient(180deg, #549E3F 0%, #92C186 100%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.flats-counter__row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.flats-counter__count {
  font-family: Oranienbaum;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  font-size: 56px;
  font-weight: 400;
  line-height: 1;
  color: rgba(255, 255, 255, 1)
}

.flats-counter__ready-text {
  font-family: Mabry Pro;
  font-weight: 400;
  font-size: 24px;
  line-height: 70%;
  letter-spacing: 0%;
  text-align: left;
}

.flats-counter__subtitle {
  font-family: Mabry Pro;
  font-weight: 400;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: 0%;
  color: rgba(255, 255, 255, 1);
}
@media (max-width: 992px) {
  .flats-counter__count {
  font-size: 48px;
  }
  .flats-counter__ready-text {
  font-size: 20px;
  }
  .flats-counter__subtitle {
  font-size: 16px;
  }
  .flats-counter__wrapper {
  padding: 15px;
  }
}
</style>
